'use client'
import dynamic from 'next/dynamic'

import { Loading } from '../../../../../loading'

export const DynamicProductSellerVoucherLabelDiscountDialogContent = dynamic(
  async () =>
    import('./ProductSellerVoucherLabelDiscountDialogContent').then(
      (mod) => mod.ProductSellerVoucherLabelDiscountDialogContent,
    ),
  {
    loading: () => <Loading />,
    ssr: false,
  },
)
